import { forwardRef, type ChangeEvent } from 'react'

import { EIcons } from '@/app/types/iconType'
import { Icon, Input, PageWrapper } from '@/shared'

import style from './Search.module.scss'

interface IProps {
    onSearch: (e: ChangeEvent<HTMLInputElement>) => void
    placeholder?: string
    // onClear?: () => void // TODO: Приделать удаление строки
}

const Search = forwardRef<HTMLInputElement, IProps>((props, ref) => {
    const { onSearch, placeholder } = props
    return (
        <PageWrapper>
            <div className={style.container}>
                <Input className={style.searchField} onChange={onSearch} placeholder={placeholder} />
                <div className={style.search}>
                    <Icon iconName={EIcons.SRCH} color='#777e90' />
                </div>
            </div>
        </PageWrapper>
    )
})

Search.displayName = 'Search'

export { Search }
